import React, { useEffect, useState } from 'react';
import { settingsApi } from '../services/api';

const SECTIONS = [
  {
    title: '📫 Balírna (kiosek)',
    fields: [
      ['packing_pin', 'PIN kód pro brigádníky (4 číslice)'],
    ]
  },
  {
    title: '🏪 Obchod',
    fields: [
      ['shop_name', 'Název obchodu'],
      ['shop_email', 'Email obchodu'],
      ['shop_phone', 'Telefon'],
      ['shop_address', 'Adresa'],
      ['shop_ico', 'IČO'],
      ['shop_dic', 'DIČ'],
    ]
  },
  {
    title: '📄 Fakturace',
    fields: [
      ['invoice_prefix', 'Prefix faktur (FAK)'],
      ['payment_days', 'Splatnost faktur (dní)'],
      ['vat_payer', 'Plátce DPH (0/1)'],
      ['shipping_cost', 'Poštovné (Kč)'],
      ['free_shipping_from', 'Doprava zdarma od (Kč)'],
    ]
  },
  {
    title: '📧 Email (SMTP)',
    fields: [
      ['smtp_host', 'SMTP server'],
      ['smtp_port', 'SMTP port'],
      ['smtp_user', 'SMTP uživatel'],
      ['smtp_password', 'SMTP heslo'],
    ]
  },
  {
    title: '📬 Příjem emailů (IMAP)',
    fields: [
      ['imap_host', 'IMAP server (např. imap.gmail.com)'],
      ['imap_port', 'IMAP port (993)'],
      ['imap_user', 'IMAP uživatel'],
      ['imap_password', 'IMAP heslo'],
    ]
  },
  {
    title: '💳 GoCardless (banka)',
    fields: [
      ['gocardless_secret_id', 'Secret ID'],
      ['gocardless_secret_key', 'Secret Key'],
      ['bank_account_id', 'ID bankovního účtu'],
    ]
  },
  {
    title: '📱 SMS brána (Android)',
    fields: [
      ['sms_gateway_url', 'URL SMS brány (http://ip:8080)'],
      ['sms_gateway_user', 'Uživatel'],
    ]
  },
  {
    title: '📣 Facebook API',
    fields: [
      ['fb_group_id', 'ID skupiny / stránky'],
      ['fb_access_token', 'Access Token'],
    ]
  },
];

export default function Settings() {
  const [settings, setSettings] = useState({});
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => { settingsApi.get().then(setSettings); }, []);

  async function save(e) {
    e.preventDefault();
    setSaving(true);
    try {
      await settingsApi.update(settings);
      setMsg('Nastavení uloženo');
      setTimeout(() => setMsg(''), 3000);
    } finally { setSaving(false); }
  }

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">⚙️ Nastavení</h1>
        <button className="btn btn-primary" onClick={save} disabled={saving}>{saving ? 'Ukládám...' : 'Uložit nastavení'}</button>
      </div>

      {msg && <div className="alert alert-success">{msg}</div>}

      <form onSubmit={save}>
        {SECTIONS.map(section => (
          <div className="card" key={section.title} style={{ marginBottom: 16 }}>
            <div className="card-title" style={{ marginBottom: 16 }}>{section.title}</div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 12 }}>
              {section.fields.map(([key, label]) => (
                <div className="form-group" key={key}>
                  <label className="form-label">{label}</label>
                  <input
                    className="form-control"
                    type={key.includes('password') || key.includes('token') || key.includes('key') ? 'password' : 'text'}
                    value={settings[key] || ''}
                    onChange={e => setSettings(s => ({...s, [key]: e.target.value}))}
                    placeholder={settings[key] === '***' ? '(uloženo — zadejte pro změnu)' : ''}
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </form>

      <div className="card" style={{ background: 'var(--blue-light)', borderLeft: '4px solid var(--blue)' }}>
        <div style={{ fontWeight: 600, marginBottom: 8 }}>ℹ️ Informace o systému</div>
        <div style={{ fontSize: 13, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
          <div>Verze: <strong>1.0.0</strong></div>
          <div>Backend: <strong>Node.js + Express</strong></div>
          <div>Databáze: <strong>SQLite</strong></div>
          <div>AI: <strong>Claude (Anthropic)</strong></div>
        </div>
      </div>
    </div>
  );
}
